function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from "react";
import { Controller } from "react-hook-form";
import Select from "react-select";
import { SelectionsLimitationType } from "../../../../../shared/types";
import AlertCircleIcon from "../../../../../shared/icons/AlertCircleIcon";
const SelectInput = ({
  registerProps,
  isError,
  fieldSettings,
  selectedOptions,
  control,
  text
}) => {
  const isLimited = fieldSettings?.selections?.type === SelectionsLimitationType.Limited;
  const isMulti = fieldSettings?.isMultipleSelection;
  const selectionsCount = selectedOptions?.length || 0;
  const isMaxSelect = selectionsCount === fieldSettings?.selections?.selectionsCount;
  const options = fieldSettings?.options?.map(option => ({
    value: option?.id,
    label: text[option?.label?.textId]
  }));
  return /*#__PURE__*/React.createElement("div", {
    style: {
      marginBottom: `${selectionsCount > 0 ? "30px" : "0px"}`
    }
  }, /*#__PURE__*/React.createElement(Controller, {
    control: control,
    name: registerProps?.name,
    render: ({
      field
    }) => /*#__PURE__*/React.createElement(Select, _extends({}, field, {
      styles: getSelectInputStyles(selectionsCount, isError),
      options: options,
      isMulti: isMulti,
      isClearable: !fieldSettings?.required,
      isOptionDisabled: () => isMulti && isLimited && isMaxSelect,
      placeholder: text[fieldSettings?.placeholder?.textId],
      classNamePrefix: "select",
      menuPortalTarget: typeof document === "undefined" ? undefined : document?.body
    }))
  }), isError && /*#__PURE__*/React.createElement(AlertCircleIcon, null));
};
export default SelectInput;

/* Styles */
const getSelectInputStyles = (selectionsCount, isError) => ({
  control: baseStyles => ({
    ...baseStyles,
    border: ` ${isError ? "1px solid #FDA29B !important" : "1px solid #D0D5DD"}  `,
    boxShadow: "0px 1px 2px rgba(16, 24, 40, 0.05)",
    borderRadius: "6px",
    "&:hover": {
      border: ` ${isError ? "1px solid #FDA29B" : "1px solid #D0D5DD"}  `
    }
  }),
  multiValue: baseStyles => ({
    ...baseStyles,
    padding: "2px 6px 2px 8px",
    background: "#F2F4F7",
    borderRadius: "16px"
  }),
  valueContainer: baseStyles => ({
    ...baseStyles,
    top: `${selectionsCount > 0 ? "45px" : "0px"}`,
    padding: `${selectionsCount > 0 ? "0px" : "2px 8px"}`
  }),
  multiValueRemove: () => ({
    color: "#667085",
    cursor: "pointer"
  }),
  indicatorSeparator: () => ({
    display: "none"
  }),
  indicatorsContainer: baseStyles => ({
    ...baseStyles,
    cursor: "pointer"
  }),
  menuPortal: baseStyles => ({
    ...baseStyles,
    zIndex: 9
  })
});
//# sourceMappingURL=SelectInput.js.map